import { defineStore } from 'pinia';
import type { _GettersTree } from 'pinia';
import type { PageActionType } from '@/design-system';
import type {
    PageActionsStateType,
    PageActionsGettersType,
    PageActionsActionsType,
} from '@/types/stores/PageActionsStoreTypes';

export const usePageActionsStore = defineStore<
    'pageActionsStore',
    PageActionsStateType,
    PageActionsGettersType & _GettersTree<PageActionsStateType>,
    PageActionsActionsType
>('pageActionsStore', {
    state: (): PageActionsStateType => ({ pageActions: [], loading: false }),

    getters: {
        hasPageActions: (state: PageActionsStateType): boolean => {
            return state.pageActions.length > 0;
        },
    },

    actions: {
        setPageActions(actions: PageActionType[]): void {
            this.pageActions = actions;
        },
        setLoading(loading: boolean): void {
            this.loading = loading;
        },

        reset(): void {
            this.pageActions = [];
            this.loading = false;
        },
    },
});
